import React from "react";

/**
 * Vintage ornamental divider — two thin gradient rules
 * meeting a centered SVG flourish. Pure presentation, no props required.
 *
 * Use between sections, above headings, or anywhere a soft
 * "country / chalkboard menu" transition is wanted.
 */
function OrnamentalDivider({ variant = "diamond", className = "" }) {
  return (
    <div
      className={`vintage-divider ${className}`}
      role="presentation"
      aria-hidden="true"
    >
      <span className="vintage-divider__ornament">
        {variant === "diamond" ? <DiamondFlourish /> : <LeafFlourish />}
      </span>
    </div>
  );
}

function DiamondFlourish() {
  return (
    <svg
      viewBox="0 0 60 18"
      width="60"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* left swirl */}
      <path d="M2 9 Q 10 2, 18 9 Q 22 12, 24 9" />
      {/* diamond */}
      <path d="M30 3 L36 9 L30 15 L24 9 Z" fill="currentColor" opacity="0.85" />
      {/* right swirl (mirrored) */}
      <path d="M58 9 Q 50 2, 42 9 Q 38 12, 36 9" />
    </svg>
  );
}

function LeafFlourish() {
  return (
    <svg
      viewBox="0 0 60 18"
      width="60"
      height="18"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.8"
    >
      <ellipse cx="30" cy="9" rx="4" ry="2.2" />
      <path d="M10 9 Q 18 4, 26 9" fill="none" />
      <path d="M50 9 Q 42 4, 34 9" fill="none" />
      <circle cx="6"  cy="9" r="1.2" />
      <circle cx="54" cy="9" r="1.2" />
    </svg>
  );
}

export default OrnamentalDivider;
